import React from "react";
import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";

import HomePage from "../pages/Home/HomePage";
// import AuthPage from "../pages/Auth/AuthPage";
// auth page v2
import AuthPageV2 from "../pages/Auth/AuthPageV2";
import { PersistGate } from "redux-persist/integration/react";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import ProjectPage from "../pages/ProjectPage/ProjectPage";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import AuditTrail from "../pages/AuditTrail/AuditTrail";
import OAuthSuccess from "../pages/Auth/Microsoft/OAuthSuccess";
import OAuthError from "../pages/Auth/Microsoft/OAuthError";
import HelpSupport from "../pages/HelpSupport/HelpSupport";
import { persistor, store } from "../store";
import { LoadScriptOnce } from "./Map/LoadScript";
import MangroveRecommendationPage from "../pages/MangroveProjectRecommendation/RecommendationPage";
import ForestRecommendationPage from "../pages/ForestProjectRecommendation/RecommendationPage";

import ProjectDesignDocuments from "../pages/ProjectDesignDocuments/ProjectDesignDocuments";
import AddNewPdd from "../pages/ProjectDesignDocuments/pages/AddNewPdd";
import { Layout } from "./Layout";
import UserManagement from "../pages/UserManagement";
import { ChakraProvider } from "@chakra-ui/react";
import { ROUTES } from "../constants/routes.const";

const App = () => {
  return (
    <ChakraProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LoadScriptOnce>
            <Routes>
              <Route element={<PublicRoute restricted redirectTo="/" />}>
                <Route path="/login" element={<AuthPageV2 />} />
                <Route path="/oauth/success" element={<OAuthSuccess />} />
                <Route path="/oauth/error" element={<OAuthError />} />
              </Route>

              <Route element={<PrivateRoute redirectTo="/login" />}>
                <Route element={<Layout />}>
                  <Route path={ROUTES.ROOT} index={true} element={<HomePage />} />
                  <Route path={ROUTES.RECOMMENDATION}>
                    <Route path="mangrove/:id" element={<MangroveRecommendationPage />} />
                    <Route path="forest/:id" element={<ForestRecommendationPage />} />
                  </Route>

                  <Route path={ROUTES.PROJECT}>
                    <Route path=":id" element={<ProjectPage />} />
                  </Route>
                  <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
                  <Route path={ROUTES.AUDIT_TRAIL} element={<AuditTrail />} />
                  <Route path={ROUTES.USERS} element={<UserManagement />} />
                  <Route path={ROUTES.HELP_SUPPORT} element={<HelpSupport />} />
                  <Route path={ROUTES.PROJECT_DESIGN_DOCUMENT}>
                    <Route path="" element={<ProjectDesignDocuments />} />
                    <Route path="Add-New-PDD" element={<AddNewPdd />} />
                  </Route>
                </Route>
              </Route>
            </Routes>
          </LoadScriptOnce>
        </PersistGate>
      </Provider>
    </ChakraProvider>
  );
};

export default App;
